import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { useTranslation } from 'react-i18next';
import uniqueId from 'lodash/uniqueId';
import {
  PopperDropdownManager,
  PopperDropdownToggle,
  PopperDropdownContent,
} from '@wix/da-shared-react/pkg/Dropdown/PopperDropdownLayout';
import StandardMenu from '@wix/da-shared-react/pkg/Dropdown/MenuPreset/StandardMenu';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/24x24/ArrowDown';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './TiersDropdown.scss';

export interface Props {
  className?: string;
  tiers: PapiDeviation[];
  selectedTier?: PapiDeviation;
  setSelectedTierId: (tierId: number) => void;
}

const TiersDropdown: React.FC<Props> = ({
  className,
  tiers,
  selectedTier,
  setSelectedTierId,
}) => {
  const { t } = useTranslation();
  const deviationCount = selectedTier?.extended?.tier?.stats?.deviations || 0;
  const postCount = selectedTier?.extended?.tier?.stats?.posts || 0;
  const id = uniqueId('tiersdropdown');

  return (
    <div className={classnames(s['root'], className)}>
      <PopperDropdownManager isInPopup>
        <PopperDropdownToggle className={s['toggle']}>
          <span>{selectedTier?.title}</span>
          <ArrowDownIcon className={s['caret']} size={IconSize.MEDIUM} />
        </PopperDropdownToggle>
        <div className={s['count']}>
          {t('widgets.tierContent.dropdown.deviations', {
            count: deviationCount,
          })}
          {' | '}
          {t('widgets.tierContent.dropdown.posts', {
            count: postCount,
          })}
        </div>
        <PopperDropdownContent
          placement="bottom-start"
          usePortal={true}
          allowFlip={false}
        >
          <StandardMenu
            id={id}
            className={s['menu']}
            items={tiers.map(tier => ({
              label: tier.title,
              value: tier.deviationId,
              className: classnames(
                tier.deviationId === selectedTier?.deviationId && s['selected']
              ),
            }))}
            onSelect={setSelectedTierId}
            scrollable
          />
        </PopperDropdownContent>
      </PopperDropdownManager>
    </div>
  );
};
TiersDropdown.displayName = 'TiersDropdown';

export default TiersDropdown;
